export default {
  en: {
    type: {
      open: 'Open',
      closed: 'Closed',
      private: 'Private',
    },

    members_count: {
      one: '%{count} member',
      other: '%{count} members',
    },

    role: {
      owner: 'Owner',
      member: 'Member',
      writer: 'Writer',
      author: 'Author',
      administrator: 'Administrator',
      super_admin: 'Super admin',
    },

    snack: {
      favorite: {
        on: 'Successfully added to favorites',
        off: 'Successfully removed from favorites',
      },
    },
  },
};
